import { useContext } from "react";
import { queryConfigContext } from "../../context";

export const useQueryConfig = () => {
  return useContext(queryConfigContext);
};
